import React, { Component } from 'react';
import { connect } from 'react-redux';
import LANGUAGES_CONTROLLER from '../../controllers/languages';
import Logger, { LOG_LEVELS } from '../../utils/logger';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import { FeatureFlagEnum } from '../../utils/enums';
import dateformat from 'dateformat';
const log = new Logger('PROCESSED_DOCUMENTS_ITEM', LOG_LEVELS.DEBUG);


class DocumentItem extends Component {
    // Handle checkbox change with parent-child relationship
    handleCheckboxChange = () => {
        const { onSelect, selected, hasChildRows, document } = this.props;

        if (onSelect) {
            // If this is a parent row with child rows, pass additional info
            if (hasChildRows) {
                onSelect(!selected, document.id, true); // true indicates it's a parent row
            } else {
                onSelect(!selected, document.id, false);
            }
        }
    };

    renderHeaderRow() {
        const {
            hasExpandableRows,
            selected,
            onSelect,
            forExport
        } = this.props;

        const enableCompanyCodeProcessedDocumentsGrid = this.props.featureFlags?.[FeatureFlagEnum.ENABLE_COMPANYCODE_PROCESSED_DOCUMENTS_GRID];

        return (
            <tr data-testid="processed-doc-grid">
                {!forExport && hasExpandableRows && <th className="expander-column"></th>}
                <th className="filename-column"><LanguageStringResolver string="processedDocuments_fileName" /></th>
                <th className="date-column"><LanguageStringResolver string="processedDocuments_dateProcessed" /></th>
                {enableCompanyCodeProcessedDocumentsGrid && (
                    <th><LanguageStringResolver string='processedDocuments_companyCode' /></th>
                )}
                <th><LanguageStringResolver
                    string={enableCompanyCodeProcessedDocumentsGrid
                        ? "processedDocuments_companyName"
                        : "processedDocuments_company"
                    }
                /></th>
                <th className="count-column"><LanguageStringResolver string="processedDocuments_processed" /></th>
                <th className="count-column"><LanguageStringResolver string="processedDocuments_error" /></th>
                <th className="count-column"><LanguageStringResolver string="processedDocuments_onHold" /></th>
                <th className="count-column"><LanguageStringResolver string="processedDocuments_pending" /></th>
                <th className="count-column"><LanguageStringResolver string="processedDocuments_totalNumber" /></th>
                {/* Checkbox column header - only show if not exporting */}
                {!forExport && (
                    <th className="checkbox-column">
                        <div className="checkbox-wrapper">
                            <input
                                type="checkbox"
                                checked={selected || false}
                                onChange={() => onSelect && onSelect(!selected)}
                                disabled={false}
                                id="select-all-checkbox"
                            />
                            <label htmlFor="select-all-checkbox">
                                <LanguageStringResolver string="processedDocuments_select" />
                            </label>
                        </div>
                    </th>
                )}
            </tr>
        );
    }

    formatProcessingDate(processingDate) {
        if (processingDate === null) {
            return LANGUAGES_CONTROLLER.format(this.props.languages, 'Processing');
        }
        else if (typeof processingDate !== 'string') {
            return LANGUAGES_CONTROLLER.format(this.props.languages, 'Unknown');
        } else {
            return processingDate.substring(0, 10);
        }
    }

    renderFileName() {
        const { document, hasChildRows, isChildRow, forExport, loadDocumentDetails } = this.props;
        
        if (hasChildRows) {
            return <strong>{document.fileName}</strong>;
        }
        
        if (isChildRow && !forExport) {
            return <a onClick={loadDocumentDetails} className="tertiary">{document.fileName}</a>;
        }
        
        return document.fileName;
    }

    renderDocumentRow() {
        const {
            document,
            isChildRow,
            hasChildRows,
            isExpanded,
            onToggleExpand,
            loadDocumentDetails,
            selected,
            forExport
        } = this.props;

        const totalNumber = (document.processedCount || 0) +
            (document.errorCount || 0) +
            (document.onholdCount || 0) +
            (document.inboxCount || 0);

        const rowClass = isChildRow ? 'child-document-row' : '';
        const checkboxId = `checkbox-${document.id}`;
        const enableCompanyCodeProcessedDocumentsGrid = this.props.featureFlags?.[FeatureFlagEnum.ENABLE_COMPANYCODE_PROCESSED_DOCUMENTS_GRID];

        return (
            <tr className={rowClass} data-testid="processed-doc-grid">
                {/* Expander cell - only show if not exporting */}
                {!forExport && (hasChildRows !== undefined || isChildRow) && (
                    <td className="expander-cell">
                        {hasChildRows && (
                            <div className="expander" onClick={onToggleExpand}>
                                {isExpanded ? (
                                    <span><s-icon name="chevron-down"></s-icon></span>
                                ) : (
                                    <span><s-icon name="chevron-right"></s-icon></span>
                                )}
                            </div>
                        )}
                        {isChildRow && <div className="child-indent-marker"></div>}
                    </td>
                )}

                <td className="filename-column">
                    {this.renderFileName()}
                </td>
                <td className="date-column">
                    {this.formatProcessingDate(document.processingDate)}
                </td>
                {enableCompanyCodeProcessedDocumentsGrid && (
                    <td>{document.userCode}</td>
                )}
                <td className="name-column">{document.userName}</td>
                <td className="count-column">{document.processedCount}</td>
                <td className="count-column">{document.errorCount}</td>
                <td className="count-column">{document.onholdCount}</td>
                <td className="count-column">{document.inboxCount}</td>
                <td className="count-column">{totalNumber}</td>

                {/* Checkbox column - only show if not exporting */}
                {!forExport && (
                    <td className="checkbox-column" onClick={(e) => e.stopPropagation()}>
                        <div className="checkbox-wrapper">
                            <input
                                type="checkbox"
                                checked={selected || false}
                                onChange={this.handleCheckboxChange}
                                disabled={false}
                                id={checkboxId}
                                data-parent={hasChildRows ? 'true' : 'false'}
                                data-child={isChildRow ? 'true' : 'false'}
                                data-document-id={document.id}
                            />
                            <label htmlFor={checkboxId}>
                                <LanguageStringResolver string="processedDocuments_selectEach" />
                            </label>
                        </div>
                    </td>
                )}
            </tr>
        );
    }

    render() {
        const { header, document } = this.props;

        if (header) {
            return this.renderHeaderRow();
        }

        if (!document) {
            return null;
        }

        return this.renderDocumentRow();
    }
}


function mapStateToProps(state, props) {
    log.debug('mapStateToProps: ', state);
    const defaultCompanyList = (state.companies && state.companies.data) || [];
    return {
        languages: state.languages,
        companyList: props.companyList || defaultCompanyList,
        featureFlags: state.featureFlag && state.featureFlag.data
    };
}


DocumentItem.defaultProps = {
    header: false,
    formInitialising: false,
    isChildRow: false,
    hasExpandableRows: false,
    forExport: false
};

export default connect(mapStateToProps)(DocumentItem);
